import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { StandardTriageRecommendationPageSelectedEventTracking } from '@/modules/auth/models/segmentevents/StandardTriageRecommendationPageSelectedEventTracking';

export class ViewedStandardTriageWarningPageEventTracking extends StandardTriageRecommendationPageSelectedEventTracking {
  static eventName: SegmentEvent = SegmentEvent.VIEWED_STANDARD_TRIAGE_WARNING_PAGE;
}
